import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { debounceTime, lastValueFrom, Observable, of, switchMap } from 'rxjs';
import { HereLookupResult, HereSearchResult, HereService } from '../../services/here.service';
import { shareReplay } from 'rxjs/operators';
import { shareReplayComponentConfig } from '../../constants';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
  selector: 'tb-address-search',
  templateUrl: './address-search.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressSearchComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() public disabled = false;
  @Input() public label = 'Search For Address';
  @Input() public hintText = 'Autofills address and coordinate fields';

  @Output() private addressResult = new EventEmitter<HereLookupResult>();

  public addressSearch = new UntypedFormControl();
  public addresses$: Observable<HereSearchResult[]>;

  constructor(private hereService: HereService) {
    this.addresses$ = this.addressSearch.valueChanges.pipe(
      debounceTime(300),
      switchMap((v) => {
        if (!v || v?.length < 3) {
          return of([] as HereSearchResult[]);
        }
        return this.hereService.searchForAddresses$(v);
      }),
      shareReplay(shareReplayComponentConfig),
    );
    this.checkDisabled();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.checkDisabled();
  }

  public ngAfterViewInit(): void {
    this.checkDisabled();
  }

  public ngOnInit(): void {
    this.checkDisabled();
  }

  public async selectAddress(address: MatAutocompleteSelectedEvent) {
    this.addressSearch.setValue(null);
    const lookup = await lastValueFrom(this.hereService.lookup$(address.option.value.id));
    this.addressResult.next(lookup);
    this.addressSearch.setValue(address.option.value.address.label);
  }

  private checkDisabled() {
    if (this.disabled) {
      this.addressSearch.disable();
    } else {
      this.addressSearch.enable();
    }
  }
}
